// CSS Modules - component class name prefix: GeoIPOverlay__

<template>
  <div v-if="changeUrl.length > 0" :class="$style.container">
    <Modal :isModalOpen="isModalOpen" @closeModal="handleClose">
      <div :class="$style.content">
        <div :class="$style.title">{{ config.title }}</div>
        <p>{{ text }}</p>
        <div class="columns is-mobile">
          <div class="column">
            <Button colour="blue" :text="config.changeButtonText" isLink :href="changeUrl" />
          </div>
          <div :class="[$style.buttonRight, 'column']">
            <Button colour="white" :text="config.stayButtonText" isClose @close="handleClose" />
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
import Button from "../Button/Button.vue";
import Modal from "../Modal/Modal.vue";
import { geoIPUrl } from "../../shared/globals";
import * as Storage from "../../shared/Storage";

export default {
  name: "GeoIPOverlay",
  components: {
    Button,
    Modal
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      countriesJSON: null,
      isModalOpen: false,
      cookieName: "hideGeoIpOverlay",
      text: "",
      changeUrl: ""
    }
  },
  methods: {
    getGeoIp() {
      axios
      .get(geoIPUrl)
      .then(response => (this.checkGeoIp(response.data[0])))
      .catch(error => console.log(error));
    },
    checkGeoIp(data) {
      if (
        this.countriesJSON &&
        data.country_code &&
        data.country_code !== "unknown" &&
        data.country_code !== this.config.websiteCountry &&
        Storage.getCookie(this.cookieName) === ""
      ) {
        for (let country in this.countriesJSON) {
          if (country === data.country_code) {
            this.changeUrl = this.countriesJSON[country].url;
            this.text = this.config.text.replace(/{{countryName}}/g, this.countriesJSON[country].name);
          }
        }
        setTimeout(() => {
          this.isModalOpen = true;
        }, 600);
      }
    },
    handleClose() {
      Storage.setSessionCookie(this.cookieName, true);
      this.isModalOpen = false;
    }
  },
  mounted() {
    if (this.config.countriesJSON) {
      axios
        .get(this.config.countriesJSON)
        .then(response => (this.countriesJSON = response.data.countries, this.getGeoIp()))
        .catch(error => console.log(error));
    }
  }
};
</script>

<style module lang="scss">
  @import "./GeoIPOverlay.scss";
</style>
